import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";
import { OPS_ROLES } from "@/lib/constants";

import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import JobsPage from "@/pages/JobsPage";
import JobDetailPage from "@/pages/JobDetailPage";
import JobFormPage from "@/pages/JobFormPage";
import DriverRoutePage from "@/pages/DriverRoutePage";
import FleetMapPage from "@/pages/FleetMapPage";
import TrackingPage from "@/pages/TrackingPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import AdminTrucksPage from "@/pages/AdminTrucksPage";
import NotificationsPage from "@/pages/NotificationsPage";

dayjs.extend(relativeTime);

function HomeRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "driver" ? "/my-route" : "/dashboard"} replace />;
}

function Shell({ children, roles }) {
  return (
    <ProtectedRoute roles={roles}>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/track/:token" element={<TrackingPage />} />

            <Route path="/" element={<HomeRedirect />} />
            <Route path="/dashboard" element={<Shell><DashboardPage /></Shell>} />
            <Route path="/jobs" element={<Shell><JobsPage /></Shell>} />
            <Route path="/jobs/new" element={<Shell roles={OPS_ROLES}><JobFormPage /></Shell>} />
            <Route path="/jobs/:id" element={<Shell><JobDetailPage /></Shell>} />
            <Route path="/jobs/:id/edit" element={<Shell roles={OPS_ROLES}><JobFormPage /></Shell>} />
            <Route path="/my-route" element={<Shell roles={["driver"]}><DriverRoutePage /></Shell>} />
            <Route path="/fleet-map" element={<Shell roles={[...OPS_ROLES, "am", "salesperson"]}><FleetMapPage /></Shell>} />
            <Route path="/admin/users" element={<Shell roles={["admin"]}><AdminUsersPage /></Shell>} />
            <Route path="/admin/trucks" element={<Shell roles={OPS_ROLES}><AdminTrucksPage /></Shell>} />
            <Route path="/notifications" element={<Shell><NotificationsPage /></Shell>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
